import { useLocation, useSearchParams } from 'react-router-dom';
import Button from '../components/common/Button';

const nextSteps = [
  'Our team reviews your application details.',
  'Shortlisted candidates may receive a group interview email.',
  'Selected candidates may be invited for a paid task round.',
  'Final shortlisted candidates may receive a personal interview call.',
];

function ApplyThankYouPage() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const jobTitle = location.state?.jobTitle || '';
  const applicationId = searchParams.get('applicationId') || '';
  const reference = applicationId ? applicationId.slice(-8).toUpperCase() : '';

  return (
    <section className="section apply-thank-you-page">
      <div className="container apply-thank-you-layout">
        <div className="apply-thank-you-hero">
          <p className="eyebrow">APPLICATION SUBMITTED</p>
          <h1>Thank you for applying to FactorStreet.</h1>
          <p>
            We have received your job application successfully. Our hiring team will review your details and
            contact you if your profile matches the role requirements.
          </p>
        </div>

        <div className="apply-thank-you-card">
          <div className="apply-thank-you-card__status">
            <span>Received</span>
            <strong>Your application has been received.</strong>
            {jobTitle ? <p>Application for: {jobTitle}</p> : null}
            {reference ? <p>Reference: {reference}</p> : null}
          </div>

          <div className="apply-thank-you-steps">
            <h2>What happens next</h2>
            <ol>
              {nextSteps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </div>

          <p className="apply-thank-you-note">
            Please check your email inbox and spam/promotions folder for updates from FactorStreet HR.
          </p>

          <div className="apply-thank-you-actions">
            <Button to="/jobs">View Current Openings</Button>
            <Button to="/hiring-process" variant="secondary">
              View Hiring Process
            </Button>
            <Button to="/" variant="secondary">
              Go Home
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ApplyThankYouPage;
